import Client from "../client";
import {
  JobStatusResponse,
  ListJobStatusResponse,
  RequestOptions,
} from "../types";

export default class JobsController {
  #client: Client;

  constructor(client: Client) {
    this.#client = client;
  }

  async getJobStatus(
    job_id: string,
    options: RequestOptions = {},
  ): Promise<JobStatusResponse> {
    const response = await this.#client.requestWithAuth(
      `/jobs/statuses/${job_id}`,
      {
        method: "GET",
        ...options,
      },
    );

    return await response.json();
  }

  async getJobStatuses(
    options: RequestOptions = {},
  ): Promise<ListJobStatusResponse> {
    const response = await this.#client.requestWithAuth("/jobs/statuses", {
      method: "GET",
      ...options,
    });

    return await response.json();
  }
}
